
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import DialogSetStaff from '../staff/components/setStaff.vue';
import { getStockInoutTypeList, stockIn } from '@/api/stock';
import { toFixed2 } from '@/utils';

@Component({
  name: 'StockInout',
  components: {
    DialogSetStaff
  }
})
export default class extends Vue {
  private formContent: any = {
    type: '',
    staff: '',
    instaff: '',
    returnParts: '',
    returnOrder: '',
    innumber: '',
    inBuyUnitPrice: '',
    customer: '',
    remark: ''
  }
  private typeOptions = []
  private dialogSelectStaffVisible = false
  private radioSelectedStaff = true
  private model : any = ''
  private stockName = ''

  private partsVisible = false;
  private orderVisible = false;
  private customerVisible = false;

   private rules = {
     type: [{ required: true, message: '请填选择入库类型', trigger: 'change' }],
     instaff: [{ required: true, message: '请填选择入库人员', trigger: 'change' }],
     innumber: [
       { required: true, message: '请填写入库数量', trigger: 'blur' },
       {  validator: this.validateDecimal, trigger: 'change' }
     ]
   }

   private orderInfo:any
   private typeInfo:any

     private validateDecimal(rule: any, value: any, callback: any) {
    //小数最多两位
    if (!/^[0-9]+(\.[0-9]{0,2})?$/.test(value)) {
      callback(new Error('请输入正确的数字格式(最多两位小数)'));
    } else {
      callback();
    }
  }

   created() {
     this.model = JSON.parse(this.$route.query.model as string);
     this.stockName = this.$route.query.stock_name.toString();
     if (this.$route.query.type) {
       this.typeInfo = JSON.parse(this.$route.query.type as string);
     }
     if (this.$route.query.order_info) {
       this.orderInfo = JSON.parse(this.$route.query.order_info as string);
     }
     if (this.orderInfo) {
       this.formContent.returnOrder = this.orderInfo;
       this.formContent.customer = parseInt(this.orderInfo.customer_company_id) !== 0 ? this.orderInfo.customer_company_name : this.orderInfo.customer_user_name;
     }
     if (this.typeInfo) {
       this.formContent.type = this.typeInfo;
       this.selectChange(this.typeInfo);
     }
     this.getStockInoutTypeList();
     this.formContent.staff = UserModule.getUserName;
     this.formContent.returnParts = this.stockName + '/' + this.model.name + '/' + this.model.serial_number + '/' + this.model.specification;
   }
   // 获取 入库类型
   private getStockInoutTypeList() {
     let params: any = {};
     params.user_id = UserModule.getUserId;
     params.user_name = UserModule.getUserName;
     params.company_id = UserModule.getCompanyId;
     params.company_name = UserModule.getCompanyName;
     if (parseInt(this.model.type) !== 1) {
       params.is_in_return = '0';
     }
     params.type = '1';
     getStockInoutTypeList(params)
       .then((res) => {
         if (res.data) {
           this.typeOptions = res.data.list;
         }
       })
       .catch((error) => {
         let msg = error.msg;
       });
   }

   private selectChange(val:any) {
     if (parseInt(val.is_in_return) === 1) {
       this.partsVisible = true;
       this.orderVisible = true;
       this.customerVisible = true;
     } else {
       this.partsVisible = false;
       this.orderVisible = false;
       this.customerVisible = false;
     }
   }

   // 点击入库人员 弹出人员弹窗
   private selectStaffHandle() {
     this.dialogSelectStaffVisible = true;
   }

   // 关闭人员弹窗
   private closeStaffHandle(val: any) {
     this.dialogSelectStaffVisible = val;
   }

   // 人员选择确定
   private selectedStaffHandle(val:any) {
     this.formContent.instaff = val;
   }

   private stockIn() {
     (this.$refs.ruleForm as any).validate((valid: any) => {
       if (valid) {
         this.stockInNet();
       } else {
         return false;
       }
     });
   }

   private stockInNet() {
     let params: any = {};
     params.user_id = UserModule.getUserId;
     params.user_name = UserModule.getUserName;
     params.company_id = UserModule.getCompanyId;
     params.company_name = UserModule.getCompanyName;
     params.model_id = this.model.id;
     params.stock_name = this.stockName;
     params.inout_type = this.formContent.type.id;
     params.inout_type_name = this.formContent.type.name;
     params.remark = this.formContent.remark;
     params.inout_user_id = this.formContent.instaff.id;
     params.inout_user_name = this.formContent.instaff.name;
     params.operate_user_id = UserModule.getUserId;
     params.operate_user_name = UserModule.getUserName;
     params.num = this.formContent.innumber;
     params.unit_price = this.model.unit_price;
     params.buy_unit_price = this.formContent.inBuyUnitPrice;
     if (this.formContent.returnOrder) {
       params.order_num = this.formContent.returnOrder.order_num;
       params.customer_company_id = this.formContent.returnOrder.customer_company_id;
       params.customer_company_name = this.formContent.returnOrder.customer_company_name;
       params.customer_name = this.formContent.customer;
       params.customer_user_id = this.formContent.returnOrder.customer_user_id;
       params.customer_user_name = this.formContent.returnOrder.customer_user_name;
       // 20211209 李闯说 parts_amount 为关联订单下所有备件数量相加之和 已经知晓关联订单下备件可能不同问题
       if (this.formContent.returnOrder.parts && this.formContent.returnOrder.parts.length > 0) {
         let amount = 0;
         this.formContent.returnOrder.parts.map(function(item:any) {
           amount = amount + item.parts_amount;
         });
         params.parts_amount = amount;
       }
     }
     params.parts_model_id = this.model.parts_model_id;
     stockIn(params)
       .then((res:any) => {
         if (res.data) {
           this.showSuccessMsg(res.msg);
           this.$router.push({
             path: 'index'
           });
         }
       })
       .catch((error) => {
         let msg = error.msg;
         this.showErrorMsg(msg);
       });
   }

   private selectedReturnOrder() {
     let data = {
       stock_name: this.stockName,
       model: this.model,
       type: this.formContent.type
     };
     this.$router.push({
       path: 'chargeOff',
       query: { 'data': JSON.stringify(data) }
     });
   }

   private formatFilter() {
      this.formContent.inBuyUnitPrice = toFixed2(this.formContent.inBuyUnitPrice);
  }

   private showErrorMsg(msg: string) {
     this.$notify({
       title: '提示',
       message: msg,
       offset: 100,
       type: 'error'
     });
   }

   private showSuccessMsg(msg: string) {
     this.$notify({
       title: '提示',
       message: msg,
       offset: window.innerHeight * 0.4,
       customClass: 'notification-center',
       type: 'success'
     });
   }
}
